"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
function ClassifyTabsPC(props) {
    var onChange = props.onChange, list = props.list, _a = props.defaultActiveIndex, defaultActiveIndex = _a === void 0 ? 0 : _a;
    var _b = react_1.default.useState(defaultActiveIndex), activeIndex = _b[0], setActiveIndex = _b[1];
    var handleClick = function (id, i) {
        setActiveIndex(i);
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    };
    return (react_1.default.createElement("div", { className: "classify-tabs-pc" }, list.map(function (o, i) {
        return (react_1.default.createElement("div", __assign({ key: i }, (o.extendProps || {}), { onClick: function () {
                handleClick(o.id, i);
            }, className: (0, classnames_1.default)('list', {
                'active-list': i === activeIndex,
            }) }),
            react_1.default.createElement("div", null, o.name)));
    })));
}
exports.default = ClassifyTabsPC;
//# sourceMappingURL=ClassifyTabsPC.js.map